"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Context = void 0;

var _react = _interopRequireDefault(require("react"));

var _Modal = _interopRequireDefault(require("./Modal"));

var _useModal2 = require("./useModal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Action;

(function (Action) {
  Action[Action["Close"] = 0] = "Close";
  Action[Action["Open"] = 1] = "Open";
})(Action || (Action = {}));

var initialState = {
  body: /*#__PURE__*/_react.default.createElement("div", null),
  footer: [],
  onClose: function onClose() {},
  visible: false
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case Action.Open:
      return _objectSpread(_objectSpread({}, action.payload), {}, {
        visible: true
      });

    case Action.Close:
      return initialState;

    default:
      throw new TypeError();
  }
};

var Context = _react.default.createContext([initialState, function () {}]);

exports.Context = Context;

var ClayModalProvider = function ClayModalProvider(_ref) {
  var children = _ref.children,
      spritemap = _ref.spritemap;

  var _React$useReducer = _react.default.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      _React$useReducer2$ = _React$useReducer2[0],
      visible = _React$useReducer2$.visible,
      otherState = _objectWithoutProperties(_React$useReducer2$, ["visible"]),
      dispatch = _React$useReducer2[1];

  var _useModal = (0, _useModal2.useModal)({
    onClose: function onClose() {
      return dispatch({
        type: Action.Close
      });
    }
  }),
      observer = _useModal.observer,
      onClose = _useModal.onClose;

  var body = otherState.body,
      center = otherState.center,
      footer = otherState.footer,
      header = otherState.header,
      size = otherState.size,
      status = otherState.status,
      url = otherState.url;

  var _footer = _slicedToArray(footer, 3),
      first = _footer[0],
      middle = _footer[1],
      last = _footer[2];

  var state = _objectSpread(_objectSpread({}, otherState), {}, {
    onClose: onClose
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, visible && /*#__PURE__*/_react.default.createElement(_Modal.default, {
    center: center,
    observer: observer,
    size: size,
    spritemap: spritemap,
    status: status
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, header), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    url: url
  }, body), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, {
    first: first,
    last: last,
    middle: middle
  })), /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: [state, dispatch]
  }, children));
};

var _default = ClayModalProvider;
exports.default = _default;